import { DeleteDeviceTrustedParams, OtpRequiredResponse } from '@repo/user-types'
import { AxiosInstance, AxiosResponse } from 'axios'

export const deleteDeviceTrusted = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: DeleteDeviceTrustedParams
}): Promise<AxiosResponse<OtpRequiredResponse>> => {
  return api.delete<OtpRequiredResponse>(`/devices/trusted/${params.id}`)
}
